<!--  -->
<template>
  <div class="sp_view">
    <div class="tabselecr_box">
      <div class="search_box">
        <!-- <el-input v-model="query.sp_strategy_no" clearable style="width:280px;margin-right:10px" placeholder="请输入策略编号" />
        <el-input v-model="query.sp_strategy_title" clearable style="width:280px;margin-right:10px" placeholder="请输入策略标题" /> -->
        <!-- <el-input v-model="query.keywords" clearable style="width:400px;" placeholder="请输入策略编号/策略标题" /> -->
        <el-input v-model="query.title" clearable style="width:400px;" placeholder="请输入标题" />
        <el-select v-model="query.trigger_type" placeholder="请选择类型">
          <el-option
            v-for="(item,i) in sparr"
            :key="i"
            :label="item"
            :value="i"
          />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="add">新增策略</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
    >
      <el-table-column
        prop="id"
        label="策略id"
        align="center"
        width="80"
      />
      <el-table-column
        prop="title"
        label="策略标题"
        align="center"
      />
      <el-table-column
        prop="trigger_type_text"
        label="触发类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.trigger_type_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="send_type_text"
        label="发送类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.send_type_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_time"
        label="创建时间"
        align="center"
      />
      <el-table-column
        label="操作"
        width="500"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="bandstaff(scope.row.id)">绑定员工</el-button>
          <el-button type="info" size="mini" @click="bandtakenotes(scope.row.id)">绑定记录</el-button>
          <el-button type="primary" size="mini" @click="sendrecord(scope.row.id)">发送记录</el-button>
          <el-button size="mini" type="primary" icon="el-icon-pie-chart" @click="look(scope.row.id)">预览</el-button>
          <!-- <el-button v-if="scope.row.sp_strategy_type!==4" type="primary" size="mini" @click="sendtakenotes(scope.row.sp_strategy_no,scope.row.push_method)">发送记录</el-button> -->
          <!-- <el-button type="warning" size="mini" @click="multiplex(scope.row.sp_strategy_no,3)">复用</el-button> -->
          <el-button type="primary" size="mini" @click="multiplex(scope.row,2)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleter(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <previewdialog ref="timepreview" />
    </el-dialog>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog>
    <el-dialog
      title="绑定群组"
      :visible.sync="dialogVisiblegroup"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <bandgroup ref="bandgroupview" @bandarr="bandarr" />
    </el-dialog>
    <el-dialog
      title="设置群"
      :visible.sync="dialogVisiblesetup"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <setup ref="setupview" @setuparr="setuparr" />
    </el-dialog>
    <el-dialog
      title="绑定失败的员工/群聊"
      :visible.sync="dialogVisibleerror"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <errorstaff ref="bandstafferrorview" />
    </el-dialog>
    <el-dialog
      title="绑定记录"
      :visible.sync="dialogVisiblenotes"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <bandnote ref="bandstaffnotesview" @updata="updata" />
    </el-dialog>
    <el-dialog
      title="发送记录"
      :visible.sync="dialogVisiblenotesSend"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <sendRecord ref="bandstaffnotesviewsend" />
    </el-dialog>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>

import previewdialog from '../enterpmessagelist/components/previewdialog.vue'
import { spWorkWechatOpStrategyIndex, spWorkWechatOpStrategydel, spWorkWechatOpStrategyStaff_bind } from '@/api/OperationStrategy.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import bandstaff from './components/bandstaff.vue'
import errorstaff from './components/errorstaff.vue'
import bandnote from './components/bandnote.vue'
import sendRecord from './components/sendRecord.vue'
import bandgroup from './components/bandnote.vue'
import setup from './components/setup.vue'
import { sprEnterprise } from '@/api/officialaccount.js'
// spMessagelisttactics
import { bindGroupChats } from '@/api/officialaccount.js'
export default {
  name: 'Enterprisemilist',
  components: { PaginationRight, bandstaff, errorstaff, bandnote, bandgroup, setup, previewdialog, sendRecord },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      dialogVisible: false,
      dialogVisibleerror: false,
      dialogVisiblenotes: false,
      dialogVisiblegroup: false,
      dialogVisiblesetup: false,
      dialogVisiblenotesSend: false,
      sendmsgdata: [],
      query: {
        title: '',
        trigger_type: '',
        page: 1,
        page_size: 10
        // keywords: null,
        // // sp_strategy_no: null,
        // // sp_strategy_title: null,
        // onlyMe: 2,
        // push_method: '',
        // sp_strategy_type: 0
      },
      // accountarr: [{
      //   value: 1,
      //   label: '查看组内策略消息'
      // }, {
      //   value: 2,
      //   label: '我关联的策略消息'
      // }],
      push_method: null,
      // accountarrsa: [
      //   {
      //     value: 1,
      //     label: '官方接口'
      //   }, {
      //     value: 2,
      //     label: '第三方接口'
      //   }],
      sparr: [],
      group_selection: null,
      priwdialogVisible: false,
      stepindex: 0

    }
  },
  watch: {
    priwdialogVisible(newValue) {
      if (!newValue) {
        this.stepindex = 0
      }
    }
  },
  created() {
    this.list()
    // if (this.$route.query.ids) {
    //   this.query.keywords = this.$route.query.ids
    // }
  },
  mounted() {

  },
  activated() {
    // if (this.$route.query.ids) {
    //   this.query.keywords = this.$route.query.ids
    // }
    this.list()
  },
  methods: {
    sendrecord(id) {
      this.dialogVisiblenotesSend = true
      this.$nextTick(() => {
        this.$refs.bandstaffnotesviewsend.send(id)
      })
    },
    async list() {
      this.loading = true
      const data = await spWorkWechatOpStrategyIndex(this.query)
      this.tableData = data.data.list
      this.accountarrsa = data.data.send_type_list
      this.sparr = data.data.trigger_type_list
      this.total = data.data.count
      this.loading = false
      console.log('data', data)
    },
    async look(id) {
      // this.sendmsgdata = row.map(v => v.sp_message_no)
      this.priwdialogVisible = true
      setTimeout(async() => {
        //   console.log(data.messag)
        this.$refs.timepreview.send(id, 'index')
      }, 100)
    },
    // 请求预览数据
    async sprEnterpriseapi(id) {
      const data = await sprEnterprise({
        sp_message_no: id
      })
      return data
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.title = null
      this.query.trigger_type = ''
      this.query.sp_strategy_type = 0
      // this.query.sp_strategy_no = null
      // this.query.sp_strategy_title = null
      this.list()
    },
    // 添加
    add() {
      this.$router.push({ path: '/OperationStrategy/add', query: { type: 1, accountarrsa: this.accountarrsa, sparr: this.sparr }})
    },
    // 复用 编辑
    multiplex(row, type) {
      this.$router.push({ path: '/OperationStrategy/add', query: { id: row, type: type, accountarrsa: this.accountarrsa, sparr: this.sparr }})
    },
    bandstaff(id, type, push_method) {
      this.push_method = push_method
      this.group_selection = type
      // eslint-disable-next-line eqeqeq
      // if (type === 1 || type == 4) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(id)
      })
      // } else if (type === 2) {
      //   this.dialogVisiblegroup = true
      //   this.$nextTick(() => {
      //     this.$refs.bandgroupview.send(id)
      //   })
      // } else {
      //   console.log('设置群')// ---------------------------------------
      //   this.dialogVisiblesetup = true
      //   this.$nextTick(() => {
      //     this.$refs.setupview.sendr(id)
      //   })
      // }
    },
    async bandarr(arr, sp_strategy_no, type) {
      const data = await spWorkWechatOpStrategyStaff_bind({
        operational_strategy_id: sp_strategy_no,
        employee_nos: arr
      })
      if (type === 1) {
        this.dialogVisible = false
      } else {
        this.dialogVisiblegroup = false
      }

      if (data.data.fail.length === 0) {
        this.$message({
          message: '绑定成功',
          type: 'success'
        })
      } else {
        this.dialogVisibleerror = true
        this.$nextTick(() => {
          this.$refs.bandstafferrorview.send(data.data.fails)
        })
      }
      console.log(data.data.fails)
    },
    async setuparr(arr, sp_strategy_no) {
      const data = await bindGroupChats({
        sp_strategy_no: sp_strategy_no,
        group_chat_ids: arr
      })

      this.dialogVisiblesetup = false
      if (data.data.fails.length === 0) {
        this.$message({
          message: '绑定成功',
          type: 'success'
        })
      } else {
        this.dialogVisibleerror = true
        this.$nextTick(() => {
          this.$refs.bandstafferrorview.send(data.data.fail)
        })
      }
    },
    bandtakenotes(sp_strategy_no, type) {
      this.dialogVisiblenotes = true
      this.$nextTick(() => {
        this.$refs.bandstaffnotesview.send(sp_strategy_no, type)
      })
    },
    updata() {
      this.dialogVisiblenotes = false
      // this.list()
    },
    deleter(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        spWorkWechatOpStrategydel({
          id: id
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.list()
        })
      }).catch(() => {

      })
    },
    async sendtakenotes(id, push_method) {
      this.$router.push({
        query: {
          id: id,
          push_method: push_method
        },
        path: '/sendlink/index'
      })
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view{
  padding: 30px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.content_box{
  width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
.sedrtw{
  width: 130px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
.active /deep/ .el-dialog__title{
  color: red;
}
.scrollable-table-cell {
  max-height: 60px;
  overflow-y: auto;
}
@media (max-width: 768px){

}
</style>
